import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  return <section className="bg-white pt-[60px] pb-10 md:pt-36 md:pb-24 px-4 overflow-hidden" data-id="element-154">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-7 pt-[0px] pb-[0px] space-y-[24px]" data-id="element-156">
          <div className="inline-block bg-primary/10 text-primary font-semibold px-4 py-1.5 rounded-full text-sm" data-id="element-157">
            Creado para mamás latinas en USA
          </div>

          <div className="space-y-4" data-id="element-158">
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-dark font-display font-extrabold tracking-headline leading-tight" data-id="element-159">
              Lanza tu primer producto digital este fin de semana usando IA...{' '}
              <span className="text-primary" data-id="element-160">
                Incluso si no tienes seguidores, no sabes de tecnología y solo
                tienes 30 minutos al día
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-body leading-relaxed font-medium" data-id="element-161">
              El método paso a paso para generar ingresos extra desde tu celular
              sin descuidar a tu familia.
            </p>
          </div>

          <div className="pt-2 space-y-3" data-id="element-162">
            <motion.a href="https://www.vitarutinas.com/cart/50347583471862:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="shimmer-cta block w-full sm:w-auto bg-cta hover:bg-orange-500 text-white font-bold rounded-2xl px-8 py-5 text-lg shadow-lg shadow-cta/25 text-center relative overflow-hidden" animate={{
            scale: [1, 1.04, 1]
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.07
          }} whileTap={{
            scale: 0.97
          }} data-id="element-163">
              SÍ, QUIERO MI PRODUCTO DIGITAL POR $6.36 →
            </motion.a>
            <p className="text-sm text-body text-center sm:text-left font-medium flex items-center justify-center sm:justify-start gap-1.5" data-id="element-164">
              Pago único • Sin suscripciones
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="lg:col-span-5 relative" data-id="element-165">
          <div className="relative rounded-[24px] overflow-hidden shadow-2xl border border-border group" data-id="element-166">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 pointer-events-none" data-id="element-167"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mozDazfnqDLdMp54N9PFAe/portada.webp" alt="Sistema Mamá IA - Tu Negocio Digital en 48 Horas" className="w-full h-auto object-cover aspect-[4/5] transform group-hover:scale-105 transition-transform duration-700" data-id="element-168" />
            <div className="absolute bottom-6 left-6 right-6 z-20" data-id="element-169">
              <div className="bg-white/95 backdrop-blur-sm shadow-xl border border-white/20 rounded-[20px] p-5 transform translate-y-0 group-hover:-translate-y-2 transition-transform duration-300" data-id="element-170">
                <p className="text-dark font-display font-bold text-xl mb-1" data-id="element-171">
                  Sistema Mamá IA
                </p>
                <p className="text-primary font-medium text-sm" data-id="element-172">
                  De cero a tu primer producto en 48 horas
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}